import React from "react";
import SectionWithMockup from "../commons/section-with-mockup";

const InvoiceLinksNextLevel = () => {
  return (
    <SectionWithMockup
      headerSeries={[
        ["Take", "your", "business"],
        ["to", "the", "next", "level"],
      ]}
      subtext="Create beautiful professional invoices embeded in simple links and give your customers flexible options to pay for them"
      image={{
        src: "https://res.cloudinary.com/catlog/image/upload/v1670997613/front-pages/mockups/invoice-payment-large-mockup.webp",
        alt: "Invoice Payment Large Mockup",
      }}
    />
  );
};

export default InvoiceLinksNextLevel;
